import React from "react";
import { Modal } from "@components/modal";
import Wrapper from "./esignModal.styles";
import actions from "@redux/esign/actions";
import { useDispatch } from "react-redux";

const EsignModal = ({ visible, children, closeable, showButton, actionButtonText, handleModalAction }) => {

    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(actions.resetEsignSubmit());
    }

  return (
    <Modal
      visible={visible}
      header="Oops, something went wrong..."
      size="small"
      closeable={closeable}
      onClose={handleClose}
      showButton={showButton}
      actionButtonText={actionButtonText}
      handleModalAction={handleModalAction}
    >
      <Wrapper>
        <div className="modalContent">
          {children}
        </div>
      </Wrapper>
    </Modal>
  );
};

export default EsignModal;
